
import {
  defineComponent, PropType, Ref, ref, watch,
} from 'vue';
import BaseItemList from '@/components/fields/BaseItemList.vue';
import {
  FieldConfig, ParserFieldObject, Property, StringMap,
} from '@/types';

export default defineComponent({
  name: 'ItemList',

  components: {
    BaseItemList,
  },

  props: {
    configs: {
      type: Object as PropType<FieldConfig>,
      required: true,
    },

    parserValues: {
      type: Object as PropType<ParserFieldObject>,
      required: true,
    },
  },

  emits: ['on-change-properties'],

  setup(props, context) {
    const property: Ref<Property> = ref(props.parserValues.properties[0]);
    const items = ref([]);

    if (property.value.value) {
      items.value = property.value.value.split(',');
    }

    watch(items, () => {
      const idField = props.configs.options.fields.id;

      const productTokens = new Map<string, string[]>();
      items.value.forEach((item: StringMap) => {
        if (item._isVariant) {
          const parentId = String(item._parentProductId ?? item[idField]);
          if (!productTokens.has(parentId)) {
            productTokens.set(parentId, []);
          }
          productTokens.get(parentId)!.push(String(item._variantElementId));
        } else {
          const productId = String(item[idField]);
          if (!productTokens.has(productId)) {
            productTokens.set(productId, []);
          }
        }
      });

      const tokens: string[] = [];
      productTokens.forEach((combinationIds, productId) => {
        if (combinationIds.length > 0) {
          tokens.push(`${productId}[${combinationIds.join(';')}]`);
        } else {
          tokens.push(productId);
        }
      });

      property.value.value = tokens.join(',');

      context.emit('on-change-properties', {
        selector: props.parserValues.selector,
        properties: [property.value],
      });
    });

    return {
      property,
      items,
    };
  },

});
